
/**
 * Slick setup
 */
$(document).ready(function () {


    // ----------------------------------------------
    // Slides (http://kenwheeler.github.io/slick/)
    // ----------------------------------------------
    $.fn.randomize = function (selector) {
        var $elems = selector ? $(this).find(selector) : $(this).children(),
            $parents = $elems.parent();

        $parents.each(function (i) {

               $(this).children(selector).sort(function (childA, childB) {
                   // * Prevent last slide from being reordered
                   if($(childB).index() !== $(this).children(selector).length - 1) {
                       return Math.round(Math.random()) - 0.5;
                   }
               }.bind(this)).detach().appendTo(this);


        });

        return this;
    };


    $('.slide-list-random').randomize().slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        customPaging: function (slider, i) {

            return '&nbsp;';
        },
        nextArrow: '<div class="slide-control next"></div>',
        prevArrow: '<div class="slide-control prev"></div>',
        slide: '.slide',
        arrows: true,
        dots: true,
        autoplay:true,
        autoplaySpeed:6000,
        //variableWidth: true
    });

    $('.slide-list').slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        customPaging: function (slider, i) {

            return '&nbsp;';
        },
        nextArrow: '<div class="slide-control next"></div>',
        prevArrow: '<div class="slide-control prev"></div>',
        slide: '.slide',
        arrows: true,
        dots: true,
        autoplay: true,
        autoplaySpeed: 6000,
        //variableWidth: true
    });

    var fadeTime   = 2000;
    var fadeDelay  = 300;
    var startDelay = 1000;
   //
    //$('.gallery-headerslider').on('init', function (event, slick, currentSlide, nextSlide) {
        //var inElt = slick.$slides.get(currentSlide);
        //$(inElt).find(".container").fadein(fadeTime);
        // console.log( $(eltBefore).find(".container"));
    //});
//var $mainSlideShow = $("#jumbotron").find(".slick-slider").find('.container').eq(0).fadeIn(fadeTime);
//$('.gallery-headerslider').on('beforeChange', function (event, slick, currentSlide) {
//var eltBefore = slick.$slides.get(currentSlide);
//$(eltBefore).find(".container").fadeOut(fadeTime);
       // console.log( $(eltBefore).find(".container"));
    //});

    //$('.gallery-headerslider').on('afterChange', function (event, slick, currentSlide) {
    // var elt = slick.$slides.get(currentSlide);
    //$(elt).find('.container').stop(true, true).delay(fadeDelay).fadeIn(fadeTime);
    //});


   /* if ($mainSlideShow.length == 1) {

        // Alle figure ausblenden
       $mainSlideShow.find(".container").hide();
        // Den 1. nach x Verzögerung einblenden
        $mainSlideShow.find(".container").eq(0).delay(startDelay).fadeIn(fadeTime);
        // Wenn die Slides wechseln, den aktiven figure ausblenden, bevor der Slide weg geschoben wird.
       $mainSlideShow.on("cycle-before", function(event, optionHash, outgoingSlideEl, incomingSlideEl, forwardFlag) {
            $(outgoingSlideEl).find(".container").stop(true, true).fadeOut(fadeTime);
        });
       // Wenn die Slides wechseln, den figure des neuen Slide einblenden, sobald er angekommen ist.
        $mainSlideShow.on("cycle-after", function(event, optionHash, outgoingSlideEl, incomingSlideEl, forwardFlag) {
            $(incomingSlideEl).find(".container").stop(true, true).delay(fadeDelay).fadeIn(fadeTime);
        });
    }*/


    $('.testimonial-list').slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        customPaging: function (slider, i) {
            return '&nbsp;';
        },
        slide: '.testimonial-entry',
        arrows: false,
        dots: false,
        autoplay: true,
        autoplaySpeed: 9000,
        //variableWidth: true
    });




    // ----------------------------------------------
    // Carousel (http://kenwheeler.github.io/slick/)
    // ----------------------------------------------
    $('.gallery-carousel').slick({
        infinite: true,
        slidesToShow: 4,
        slidesToScroll: 4,
        customPaging: function (slider, i) {
            return '&nbsp;';
        },
        responsive: [
            {
                breakpoint: 1500,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                    infinite: true,
                    dots: true
                }
            },
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    infinite: true,
                    dots: true
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    dots: true
                }
            },
            {
                breakpoint: 300,
                settings: "unslick"
            }
            // You can unslick at a given breakpoint now by adding:
            // settings: "unslick"
            // instead of a settings object
        ],
        arrows: false,
        dots: true
        //variableWidth: true
    });

});

